import Cookie from 'js-cookie';

export const UNRECOGNISED_SERVER_ERROR = 'UNRECOGNISED_SERVER_ERROR';
export const CONNECTION_ERROR = 'CONNECTION_ERROR';
export const WRONG_PARAMS = 'WRONG_PARAMS';
export const PAYMENT_ERROR = 'PAYMENT_ERROR';
export const UNPROCESSABLE = 'UNPROCESSABLE__MOST_LIKELY_EXPIRED_CACHE';
export const UNHANDLED_SERVER_FAILURE = 'UNHANDLED_SERVER_FAILURE';
export const EXTERNAL_API_FAILURE = 'EXTERNAL_API_FAILURE';
export const SERVER_TEMPORARY_UNAVAILABLE = 'SERVER_TEMPORARY_UNAVAILABLE';
export const NOT_FOUND = 'NOT_FOUND';
export const ENDPOINT_SEARCH = '/_cars/search/suggestKey';
export const ENDPOINT_INFO = '/_cars/info';
export const ENDPOINT_PAYMENT = '/_cars/order/book';
export const MARKETING_COOKIES = ['referrer', 'referrer_mrk', 'smrk1', 'smrk2', 'smrk3'];
export const KM_COOKIES = [...MARKETING_COOKIES, 'abst'];

export const SORT__PRICE__LOW_TO_HIGH = 'SORT__PRICE__LOW_TO_HIGH';
export const TRANSMISSION_DEFAULT = 'AM';
export const CURRENCY_DEFAULT = 'RUB';
export const LANG_DEFAULT = 'ru';

export const errorParser = (responseFromServer) => {
  switch (responseFromServer.status) {
    case undefined:
      return { type: CONNECTION_ERROR };
    case 400:
      return { type: WRONG_PARAMS };
    case 402:
      return { type: PAYMENT_ERROR };
    case 404:
      return { type: NOT_FOUND };
    case 422:
      return { type: UNPROCESSABLE };
    case 500:
      return { type: UNHANDLED_SERVER_FAILURE };
    case 502:
      return { type: EXTERNAL_API_FAILURE };
    case 503:
      return { type: SERVER_TEMPORARY_UNAVAILABLE };
    default:
      return { type: UNRECOGNISED_SERVER_ERROR };
  }
};

export const getCookies = (neededCookies) =>
  neededCookies.reduce((params, cookieName) => {
    const cookie = Cookie.get(cookieName);
    if (cookie) {
      // eslint-disable-next-line no-param-reassign
      params[cookieName] = cookie;
    }

    return params;
  }, {});
